let callback: (() => void) | null = null;

export const sessionStore = {
  setSessionExpiredHandler(fn: () => void) {
    callback = fn;
  },
  notifySessionExpired() {
    if (callback) callback();
  },
};
